// extracted by mini-css-extract-plugin
export default {"createButton":"Author_createButton__coF1T","createButtonImg":"Author_createButtonImg__ykRLo","createButtonText":"Author_createButtonText__X2Mab"};